import { Wrapper, Content, ContentInner, Footer } from './General';
import Header from './Header';

export { Wrapper, Content, Header, ContentInner, Footer };
